import { __rest } from '../../_virtual/_tslib.js';
import React__default from 'react';

const A = (_a) => {
    var { openInNewTab, title, href, className, children } = _a, props = __rest(_a, ["openInNewTab", "title", "href", "className", "children"]);
    return (React__default.createElement("a", Object.assign({ href: href, target: openInNewTab ? "_blank" : undefined, rel: "noopener noreferrer", title: title, className: className }, props), children));
};

export { A as default };
//# sourceMappingURL=A.js.map
